var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('vx-card',{staticClass:"shadow-none text-center"},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.$t('global.No_data')))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }